import React, {ReactNode} from 'react';
import classNames from 'classnames';
import {useField} from 'formik';

interface Props {
  onChange?: (value: string) => void;
  name: string;
  options: {value: string; display: ReactNode}[];
}

const RadioButtons = ({name, options, onChange}: Props) => {
  const [gradeInput, , gradeInputHelpers] = useField('grade.gradeInput');

  return (
    <div className="shared-button-group" data-testid="button-group">
      {options.map(({value, display}) => {
        const selected = `${value}` === `${gradeInput.value}`;

        return (
          <label
            key={`grade-input-${value}`}
            className={classNames('shared-button-group-item', {selected})}
            data-testid={display}
          >
            {display}
            <input
              name={name}
              onClick={() => {
                gradeInputHelpers.setValue(value);

                if (onChange) {
                  onChange(value);
                }
              }}
              style={{display: 'none'}}
              type="radio"
              value={value}
              data-testid="radio-button-input"
            />
          </label>
        );
      })}
    </div>
  );
};

export default RadioButtons;
